import { render, staticRenderFns } from "./ProjectExpenseList.vue?vue&type=template&id=2bfaacd9"
import script from "./ProjectExpenseList.vue?vue&type=script&lang=js"
export * from "./ProjectExpenseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports